import { MAIN_PACE_TASK_IDs } from '@symfa-inc/providence-types';

export const ACCOUNTING_PACE_TASKS: Record<string, string> = {
  RE015: MAIN_PACE_TASK_IDs.leasingComplete,
  RE020: MAIN_PACE_TASK_IDs.siteAcqComplete,
  RE066: MAIN_PACE_TASK_IDs.zoningAppDeemedComplete,
  SS010: MAIN_PACE_TASK_IDs.candidateApproved,
};
